import { render, staticRenderFns } from "./MedicalReportHistory.vue?vue&type=template&id=53f0ef12"
import script from "./MedicalReportHistory.vue?vue&type=script&lang=js"
export * from "./MedicalReportHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports